import constant from '@/constant'

// state
const _state = {
  isSlideTypeNoAudio: false,
}

// getters
const _getters = {
  getSlideTypeList: () => {
    return constant.allTypeSections
  },
}

// mutations
const mutations = {

}

// actions
const actions = {

}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
